import {darken, lighten} from '@mui/material/styles';
import theme from '../../../theme/Theme';

export const builderGridStyles = () => {
  const getBackgroundColor = (color: string) =>
    (theme.palette as any).mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.9);
  const getHoverBackgroundColor = (color: string) =>
    (theme.palette as any).mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);
  return {
    root: {
      height: '100%',
      flexGrow: 1,
      position: 'relative',
    },
    dataGridRoot: {
      '& .recommends-primary': {},
      '& .recommends-sub': {
        backgroundColor: getBackgroundColor(theme.palette.info.main),
        '&:hover': {
          backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
        },
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: 'white',
        zIndex: 2,
      },
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 3,
      textAlign: 'center',
      padding: '1rem',
    },
    lockIcon: {
      fontSize: 48,
      color: 'white',
      marginBottom: '1rem',
    },
    overlayText: {
      color: 'white',
      fontSize: '1rem',
    },
    text: {
      color: 'white',
      textDecoration: 'none',
      fontWeight: 'bold',
    },
  };
};
